import { useEffect, useState } from 'react';
import { API_URLS } from '../apiUrl';
import Pagination from '@mui/material/Pagination';
import axiosInstance from '../components/axiosInstance';

const SurveyReport = ({ showModal, handleClose, surveyorId, municipalityId, holdingId }: any) => {

    const [surveyData, setSurveyData] = useState<any>([]);
    const [searchTerm] = useState<string>('');
    const [inputData] = useState({ page: 1, limit: 50 });

    useEffect(() => {
        const fetchSurveyData = async () => {
            try {
                const response = await axiosInstance.post(API_URLS.FetchSurveyData, {
                    page: inputData.page,
                    limit: inputData.limit,
                    municipality_id: municipalityId,
                    surveyorId: surveyorId
                });

               
                const holdingIdMatching = response.data.holding_info.filter((item: any) => item.holding_primary_id === holdingId)

                setSurveyData(holdingIdMatching);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchSurveyData();
    }, [municipalityId, surveyorId, inputData.page, holdingId]);

    const filteredSurveyData = surveyData?.filter((row: any) => {
        return (
            row.holding_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.holding_type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.name_of_complex_apartment?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.total_cover_area?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.property_jl_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.property_khatiyan_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.property_plot_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.property_owner_spouse_name_father_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.property_annual_valuation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.property_quaterly_tax?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.holding_mouza_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.ward_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.borough_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.ownership?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.total_la_sqft?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

 
    const [reportData, setReportData] = useState<any>([]);
    const [pageInput, setPageInput] = useState({ page: 1, limit: 6 });
    const [pagecount, setPageCount] = useState(0);
    const [itemsPerPageInReport] = useState(6);


    const reportPagination = (event: any, value: number) => {
        setPageInput((prevData) => ({
            ...prevData,
            page: value, 
        }));
    };

    const reportTotalPages = Math.ceil(pagecount / itemsPerPageInReport);

    useEffect(() => {
        const fetchSurveyData = async () => {
            try {
                const response = await axiosInstance.post(API_URLS.GetSurveyReport, {
                    page: pageInput.page,
                    limit: pageInput.limit,
                    municipality_id: municipalityId,
                    surveyorId: surveyorId,
                    holdingId: holdingId
                });

               
                setReportData(response.data.assignRows);
                setPageCount(response.data.totalCount);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchSurveyData();
    }, [municipalityId, surveyorId, pageInput.page, holdingId]);


    ///////////////////// COMMON SERVEY REPORT IN Modal ///////////////////////////////


    const [commonData, setCommonData] = useState<any>([]);

    useEffect(() => {
        const fetchSurveyCommonData = async () => {
            try {
                const response = await axiosInstance.post(API_URLS.GetCommonSurveyData, {
                    municipality_id: municipalityId,
                    holdingId : holdingId
                });
                setCommonData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchSurveyCommonData();
    }, [municipalityId, holdingId]);



    const modifiedData = commonData.map((item: any) => {
        return {
          ...item, 
          building_picture: item.building_picture?.replace("/var/www/html/SurveyApp", "")
        };
      });

   

    return (
        <div
            className={`fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50 ${showModal ? 'block' : 'hidden'}`}
            onClick={handleClose}
        >
            <div className="bg-white rounded-lg shadow-lg xl:w-[1200px] lg:w-[960px] md:w-[700px] sm:w-[500px] w-full"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="flex gap-4 items-center p-4 border-b border-gray-200">
                    <div className='flex gap-3'>
                        <div className='flex gap-1'><i className="ri-check-line text-green-500"></i><span>Completed</span></div>
                        <div>|</div>
                        <div className='flex gap-1'><i className="ri-close-large-line text-red-500"></i><span>Not Started</span></div>
                        <div>|</div>
                        <div className='flex gap-1'><i className="ri-hourglass-fill text-orange-500"></i><span>In Progress</span></div>
                    </div>
                    {/* <h2 className="text-xl font-semibold">Survey Report</h2> */}
                    <button className="text-gray-500 ml-auto" onClick={handleClose}><i className="ri-close-large-line"></i></button>
                </div>
                <div className="h-[calc(100vh-80px)] overflow-y-auto">
                    <div className="flex flex-col gap-y-4 p-4 pb-6 border-b border-gray-200">
                        <h3 className="text-xl font-semibold">Assigned Holding Details By Admin</h3>

                        <div className="p-4 rounded-xl border border-slate-200 bg-slate-50">

                            {filteredSurveyData?.map((row: any, index: any) => (
                                <div className="flex flex-wrap gap-y-2 -mx-2" key={index}>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Holding No :</div>
                                        <div>{row.holding_no}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Owner Name :</div>
                                        <div>{row.ownership == null ? "N/A" : row.ownership}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Holding Type :</div>
                                        <div>{row.holding_type == null ? "N/A" : row.holding_type}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Name of Complex/Apartment :</div>
                                        <div>{row.name_of_complex_apartment == null ? "N/A" : row.name_of_complex_apartment}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Total Covered Area :</div>
                                        <div>{row.total_cover_area == null ? "N/A" : row.total_cover_area}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Property JL No. :</div>
                                        <div>{row.property_jl_no == null ? "N/A" : row.property_jl_no}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Property Khatiyan No. :</div>
                                        <div>{row.property_khatiyan_no == null ? "N/A" : row.property_khatiyan_no}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Property Plot No. :</div>
                                        <div>{row.property_plot_no == null ? "N/A" : row.property_plot_no}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">C/O :</div>
                                        <div>{row.property_owner_spouse_name_father_name == null ? "N/A" : row.property_owner_spouse_name_father_name}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Property Annual Valuation :</div>
                                        <div>{row.property_annual_valuation == null ? "N/A" : row.property_annual_valuation}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Property Quaterly Tax :</div>
                                        <div>{row.property_quaterly_tax == null ? "N/A" : row.property_quaterly_tax}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Holding Mouza Name :</div>
                                        <div>{row.holding_mouza_name == null ? "N/A" : row.holding_mouza_name}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Ward No. :</div>
                                        <div>{row.ward_no == null ? "N/A" : row.ward_no}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Borough Name :</div>
                                        <div>{row.borough_name == null ? "N/A" : row.borough_name}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                        <div className="font-semibold">Total Land Sqft :</div>
                                        <div>{row.total_la_sqft == null ? "N/A" : row.total_la_sqft}</div>
                                    </div>
                                    <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full">
                                        <div className="font-semibold">Survey Status :</div>
                                        <div>
                                            <button
                                                className={`mr-2 
                                                            ${row.is_survey_completed == 1 ? 'bg-green-500' :
                                                        row.is_survey_completed == 0 ? 'bg-red-500' :
                                                            row.is_survey_completed == 3 ? '' : ''} 
                                                            text-white py-1 px-3 rounded-full`}
                                            >
                                                {row.is_survey_completed == 1 ? '✔' :
                                                    row.is_survey_completed == 0 ? '✘' :
                                                        row.is_survey_completed == 3 ? '⏳' : ''}
                                            </button>
                                        </div>
                                    </div>
                                </div>))}
                        </div>
                    </div>

                    <div className="flex flex-col gap-y-4 p-4 border-b border-gray-200">
                        <h3 className="text-xl font-semibold">Survey Report</h3>


                        {reportData.length < 1 ?

                            <div className="py-2 text-center text-slate-500 p-4 rounded-lg border border-slate-200 bg-slate-50">
                                <span className="font-medium">No Report Found</span>
                            </div> :


                            <>
                                <div className="">
                                    <div className='flex-grow overflow-auto max-h-72'>
                                        <table className="min-w-full table-auto">
                                            <thead className="border-b">
                                                <tr>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Number Of Storey</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Floor Number</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Number Of Unit</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Area Covered</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Property Type</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Property Type Description</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Use Of Property</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Purpose Of Property</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Property Description</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Occupancy Type</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Floor Type</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Roof Type</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Wall Type</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Survey Date</th>
                                                    <th className="sticky top-0 py-2 px-4 text-left bg-white">Last Updated</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reportData?.map((row: any, index: any) => (
                                                    <tr key={index} className="border-b">
                                                        <td className="py-2 px-4">{row.number_of_storied}</td>
                                                        <td className="py-2 px-4">Floor-{row.floor_number == null ? "N/A" : row.floor_number}</td>
                                                        <td className="py-2 px-4">Unit-{row.number_of_unit == null ? "N/A" : row.number_of_unit}</td>
                                                        <td className="py-2 px-4">{row.coverd_area == null ? "N/A" : row.coverd_area}</td>
                                                        <td className="py-2 px-4">{row.type_name == null ? "N/A" : row.type_name}</td>
                                                        <td className="py-2 px-4">{row.type_description_name == null ? "N/A" : row.type_description_name}</td>
                                                        <td className="py-2 px-4">{row.use_of_property == null ? "N/A" : row.use_of_property}</td>
                                                        <td className="py-2 px-4">{row.perpose_of_use == null ? "N/A" : row.perpose_of_use}</td>



                                                        <td className="py-2 px-4">
                                                            {row.description_names && row.description_names[0] !== null
                                                                ? row.description_names.join(", ")
                                                                : "N/A"}
                                                        </td>

                                                        <td className="py-2 px-4">{row.occupancy_type == null ? "N/A" : row.occupancy_type}</td>
                                                        <td className="py-2 px-4">{row.floor_type == null ? "N/A" : row.floor_type}</td>
                                                        <td className="py-2 px-4">{row.roof_type == null ? "N/A" : row.roof_type}</td>
                                                        <td className="py-2 px-4">{row.wall_type == null ? "N/A" : row.wall_type}</td>
                                                        <td className="py-2 px-4">{row.survey_date == null ? "N/A" : row.survey_date}</td>
                                                        <td className="py-2 px-4">{row.last_updated == null ? "N/A" : row.last_updated}</td>
                                                        <td className="py-2 px-4">
                                                            <button
                                                                className={`mr-2 
                                                            ${row.is_survey_completed == 1 ? 'bg-green-500' :
                                                                        row.is_survey_completed == 0 ? 'bg-red-500' :
                                                                            row.is_survey_completed == 3 ? '' : ''} 
                                                            text-white py-1 px-3 rounded-full`}
                                                            >
                                                                {row.is_survey_completed == 1 ? '✔' :
                                                                    row.is_survey_completed == 0 ? '✘' :
                                                                        row.is_survey_completed == 3 ? '⏳' : ''}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {reportData?.length === 0 ? null :
                                        <div className="flex justify-center mt-4">

                                            <Pagination
                                                count={reportTotalPages} // Set the total pages dynamically based on totalItems
                                                page={pageInput.page}
                                                onChange={reportPagination}
                                                color="primary" />
                                        </div>}
                                </div>
                            </>}

                      
                    </div>

                    <div className="flex flex-col gap-y-4 p-4 pb-6 border-b border-gray-200">
                        <h3 className="text-xl font-semibold">Common Holding Survey Report By Surveyor</h3>
                        <div className="p-4 rounded-xl border border-slate-200 bg-slate-50">

                            {modifiedData?.map((row: any, index: any) => (
                                <div className="flex flex-wrap gap-y-2 -mx-4">
                                    <div className="2xl:w-2/12 xl:w-3/12 md:w-4/12 w-full px-4">
                                        <div className='[&_img]:w-full'>
                                       { row.building_picture == null ? <i className="ri-file-image-fill" style={{ fontSize: '50px' }}></i> :
                                            <img  src={`${process.env.REACT_APP_API_URL}${row.building_picture}`}  alt="" /> }
                                        </div>
                                    </div>
                                    <div className="2xl:w-10/12 xl:w-9/12 md:w-8/12 w-full px-4">
                                        <div className="flex flex-wrap gap-y-2 -mx-2" key={index}>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Property Year</div>
                                                <div>{row.year_of_property  == null ? "N/A" : row.year_of_property}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Water Connection :</div>
                                                <div>{row.water_connection == null ? "N/A" : row.water_connection}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Electricity Available :</div>
                                                <div>{row.is_electricity_available == null ? "N/A" : row.is_electricity_available}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Facing :</div>
                                                <div>{row.facing == null ? "N/A" : row.facing}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Road Width :</div>
                                                <div>{row.road_width_front_premises == null ? "N/A" : row.road_width_front_premises}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Road Type :</div>
                                                <div>{row.type_of_road == null ? "N/A" : row.type_of_road}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Nearest Railway Station :</div>
                                                <div>{row.nearest_railway == null ? "N/A" : row.nearest_railway}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Nearest Market :</div>
                                                <div>{row.nearest_market == null ? "N/A" : row.nearest_market}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Nearest Institute :</div>
                                                <div>{row.nearest_school_institute == null ? "N/A" : row.nearest_school_institute}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Tower Installed :</div>
                                                <div>{row.is_tower_install == null ? "N/A" : row.is_tower_install}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Other Holdings Installed :</div>
                                                <div>{row.is_any_holding_installed == null ? "N/A" : row.is_any_holding_installed}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Swage Connection :</div>
                                                <div>{row.is_swage_connection == null ? "N/A" : row.is_swage_connection}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Central A/C :</div>
                                                <div>{row.central_ac == null ? "N/A" : row.central_ac}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Lift :</div>
                                                <div>{row.lift == null ? "N/A" : row.lift}</div>
                                            </div>
                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Building Approved Plan :</div>
                                                <div>{row.building_approved_plan == null ? "N/A" : row.building_approved_plan}</div>
                                            </div>

                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold"> Property latitude :</div>
                                                <div>{row.property_lat == null ? "N/A" : row.property_lat}</div>
                                            </div>

                                            <div className="flex gap-3 px-2 py-2 2xl:w-3/12 xl:w-4/12 md:w-6/12 w-full border-b border-slate-200">
                                                <div className="font-semibold">Property Longitude :</div>
                                                <div>{row.property_long == null ? "N/A" : row.property_long}</div>
                                            </div>

                                            
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>



                </div>
            </div>
        </div>
    );
};

export default SurveyReport;

